import { useCreateUtilityFAQClickedAnalytics } from "@/libs/analytics/analyticsHooks";
import InlineSvg from "@/src/components/InlineSvg";
import { TextButton } from "@/src/components/links/components/TextButton";
import MarketplaceModal from "@/src/components/Modal/MarketplaceModal";
import RichTextRenderer from "@/src/components/RichTextRenderer";
import { Body7 } from "@/src/components/typography/components/Body";
import { BodyName } from "@/src/components/typography/components/Body/types";
import { Label5, Label6 } from "@/src/components/typography/components/Label";
import { UtilityBadgeType } from "@/src/types";
import clsx from "clsx";
import { useState } from "react";

const UtilityModalContent = ({ badges }: { badges: UtilityBadgeType[] }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const onUtilityFAQClicked = useCreateUtilityFAQClickedAnalytics();
  const handleUtilityFAQClicked = () => {
    onUtilityFAQClicked();
    setModalOpen(true);
  };

  return (
    <>
      <TextButton
        onClick={handleUtilityFAQClicked}
        linkType={"underlined"}
        className="my-8"
        size="sm"
      >
        What is utility?
      </TextButton>
      <MarketplaceModal
        isOpen={modalOpen}
        classes={{ modal: "border border-gray-500 text-white" }}
        onClose={() => setModalOpen(false)}
        title="What is utility?"
      >
        <Body7 md={BodyName.Body_5} className="mt-6 mb-9">
          Some Nike Virtual Creations are equipped with utility and offer unique
          benefits to their owners, such as special access to products,
          experiences, and more.
        </Body7>

        {badges.map(({ name, image, description }) => {
          const assetUrl = image.asset.url; // TODO: use createLocalAssetUrl after assets API is finished

          return (
            <div key={name} className="laptop:gap-10 flex gap-4">
              <div>
                <InlineSvg
                  asset={{ url: assetUrl, description: image.description }}
                  className={clsx("laptop:w-[72px] w-[51px]")}
                />
              </div>
              <div>
                <Label5>{name}</Label5>
                <Body7 className="text-gray-350 mt-1 mb-6">
                  <RichTextRenderer richText={description} />
                </Body7>
              </div>
            </div>
          );
        })}
      </MarketplaceModal>
    </>
  );
};

export default UtilityModalContent;
